import { Controller } from "@hotwired/stimulus"
import { animate, spring } from "motion"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 3000 } // Default duration is 3 seconds (3000ms)
  }

  connect() {
    // Set initial state (invisible, slightly above)
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateY(-20px)'

    // Entrance animation with spring physics
    animate(
      this.element,
      {
        opacity: [0.5, 1],
        transform: ['translateY(-20px)', 'translateY(0)']
      },
      { type: spring, bounce: 0, duration: 0.8 }
    )

    // Auto-dismiss timer
    this.timeout = setTimeout(() => {
      this.dismiss()
    }, this.durationValue)
  }

  disconnect() {
    // Clear the timeout if the controller disconnects
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    // Zoom out and fade out animation
    animate(
      this.element,
      {
        opacity: [1, 0]
      },
      {
        duration: 0.3,
        easing: 'ease-out'
      }
    ).finished.then(() => {
      // Remove element after animation completes
      this.element.remove()
    })
  }
}